module.exports = __webpack_public_path__ + "img/Key3.db6589d4.gif";